import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-quadrant-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quadrant-chart.component.html',
  styleUrl: './quadrant-chart.component.scss'
})
export class QuadrantChartComponent implements OnInit, OnChanges {
  @Input() xValue: number = 2.5; // 0-5 scale within the quadrant
  @Input() yValue: number = 2.5; // 0-5 scale within the quadrant
  @Input() personalityType: 'Popular' | 'Performer' | 'Procrastinator' | 'Pusher' = 'Popular';

  // Make Math available in template
  Math = Math;

  pointX: number = 0;
  pointY: number = 0;
  rectX: number = 0;
  rectY: number = 0;
  rectWidth: number = 0;
  rectHeight: number = 0;

  // Quadrant colors
  private readonly colors = {
    Popular: '#0BBFAA',      // Top Left
    Performer: '#EF9308',    // Top Right
    Procrastinator: '#A5B106', // Bottom Left
    Pusher: '#8D6CB8'        // Bottom Right
  };

  ngOnInit(): void {
    this.calculatePosition();
  }

  ngOnChanges(): void {
    this.calculatePosition();
  }

  private calculatePosition(): void {
    // Each quadrant is 160x160 pixels
    const quadrantSize = 160;
    const pixelsPerUnit = quadrantSize / 5; // 32 pixels per unit (0-5 scale)

    // Calculate the rectangle and point based on personality type
    switch (this.personalityType) {
      case 'Popular': // Top Left
        // Origin at bottom-right of quadrant (200, 200)
        this.rectX = 200 - (this.xValue * pixelsPerUnit);
        this.rectY = 200 - (this.yValue * pixelsPerUnit);
        this.rectWidth = this.xValue * pixelsPerUnit;
        this.rectHeight = this.yValue * pixelsPerUnit;
        this.pointX = this.rectX;
        this.pointY = this.rectY;
        break;

      case 'Performer': // Top Right
        // Origin at bottom-left of quadrant (200, 200)
        this.rectX = 200;
        this.rectY = 200 - (this.yValue * pixelsPerUnit);
        this.rectWidth = this.xValue * pixelsPerUnit;
        this.rectHeight = this.yValue * pixelsPerUnit;
        this.pointX = 200 + (this.xValue * pixelsPerUnit);
        this.pointY = this.rectY;
        break;

      case 'Procrastinator': // Bottom Left
        // Origin at top-right of quadrant (200, 200)
        this.rectX = 200 - (this.xValue * pixelsPerUnit);
        this.rectY = 200;
        this.rectWidth = this.xValue * pixelsPerUnit;
        this.rectHeight = this.yValue * pixelsPerUnit;
        this.pointX = this.rectX;
        this.pointY = 200 + (this.yValue * pixelsPerUnit);
        break;

      case 'Pusher': // Bottom Right
        // Origin at top-left of quadrant (200, 200)
        this.rectX = 200;
        this.rectY = 200;
        this.rectWidth = this.xValue * pixelsPerUnit;
        this.rectHeight = this.yValue * pixelsPerUnit;
        this.pointX = 200 + (this.xValue * pixelsPerUnit);
        this.pointY = 200 + (this.yValue * pixelsPerUnit);
        break;
    }
  }

  getQuadrantColor(personalityType: string): string {
    return this.colors[personalityType as keyof typeof this.colors] || '#F3F4F6';
  }
}
